module.exports = __webpack_public_path__ + "img/img (1).3258a0d5.png";